import React, { useEffect,useState,useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { FaCloudUploadAlt, FaFilePdf } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
  } from "@mui/material";
import Pagination from 'react-bootstrap/Pagination';

function TerminateOrder() {
  const [tokenNow, setTokenNow] = useState('');
  const [authByToken, setAuthByToken] = useState('');
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [errorUpload, setErrorUpload] = useState("");

  const [terminationListByRequestor, setTerminationListByRequestor] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openInputSuccess, setOpenInputSuccess] = useState(false);
  const [openInputFail, setOpenInputFail] = useState(false);
  const [selectedOption, setSelectedOption] = useState("keyRequestor");

  const [selectedRows, setSelectedRows] = useState([]);

  // Cable Id
  const [selectedCableId, setSelectedCableId] = useState("");
  const [inputCableId, setInputCableId] = useState("");

  // SalesOrderNo
  const [selectedSalesOrderNo, setSelectedSalesOrderNo] = useState("");
  const [inputSalesOrderNo, setInputSalesOrderNo] = useState("");

  // Requestor
  const [selectedRequestor, setSelectedRequestor] = useState("");
  const [inputRequestor, setInputRequestor] = useState("");

  // Destination
  const [selectedDestination, setSelectedDestination] = useState("");
  const [inputDestination, setInputDestination] = useState("");

  const resource = "terminate-order";

    useEffect(() => {
      const storedToken = localStorage.getItem('token');
   
        const checkSessionToken = async () => {
          try {
            const response = await fetch(
              `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
    
            if (!response.ok) {
              setError(data.message || "Failed to fetch session token data");
              throw new Error(data.message || "Failed to fetch session token data");
            }
    
            // Parse response text as a boolean value
            const text = await response.text();
            const data = text === "true";
    
            if (data) {
            } else {
              window.alert("Session is invalid");
              navigate("/login");
            }
          } catch (error) {
            console.error("Fetch Error:", error.message);
            setError("Fetch Error: " + error.message);
          }
        };
    
        checkSessionToken();

      if (storedToken) {   
        loadUserByToken(storedToken);
      }
        setTokenNow(storedToken);
        defaultPage(storedToken);
      }, []);


      function defaultPage(storedToken) {
        setInputRequestor()
        loadTerminationListByRequestor(
          selectedOption,
          "",
          "",
          storedToken
        );
      }
      
       useEffect(() => {
         if (selectedCableId !== "") {
          loadTerminationListByRequestor(selectedOption, selectedCableId);
         } else if (selectedSalesOrderNo !== "") {
          loadTerminationListByRequestor(selectedOption, selectedSalesOrderNo);
         } else if (selectedRequestor !== "") {
          loadTerminationListByRequestor(selectedOption, selectedRequestor);
         } else if (selectedDestination !== "") {
          loadTerminationListByRequestor(selectedOption, selectedDestination);
         } 
       }, [
         selectedCableId,
         selectedSalesOrderNo,
         selectedRequestor,
         selectedDestination,
         tokenNow,
       ]);

       const resetFiltersExcept = (filterType) => {
        if (filterType !== "cableId") {
          setSelectedCableId("");
          setInputCableId("");
        }
    
        if (filterType !== "salesOrderNo") {
          setSelectedSalesOrderNo("");
          setInputSalesOrderNo("");
        }
        if (filterType !== "requestor") {
          setSelectedRequestor("");
          setInputRequestor("");
        }

        if (filterType !== "destination") {
          setSelectedDestination("");
          setInputDestination("");
        }
      };
       
      const loadUserByToken = async (token) => {
        const result = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${token}`);       
        setAuthByToken(result.data[0])
        setInputRequestor(result.data[0].company_name)
      }
    
      const loadTerminationListByRequestor = async (key, value1, value2, token) => {
        try {
          if (tokenNow !== "" && tokenNow !== null) {
            const result = await axios.get(
              `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/find-by-requestor?param1=${key}&param2=${value1}&param3=${value2}&token=${tokenNow}`
            );
            const data = result.data;
            setTerminationListByRequestor(data);
          } else {
            const result = await axios.get(
              `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/find-by-requestor?param1=${key}&param2=${value1}&param3=${value2}&token=${token}`
            );
            const data = result.data;
            setTerminationListByRequestor(data);
          }
        } catch (error) {
          console.error("Error loading order list:", error);
        }
      };

      function getLocalDate() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    function getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
      const day = String(now.getDate()).padStart(2, '0');

      return `${day}/${month}/${year}`;
  }
  
      const handleSubmit = async (event) => {

          event.preventDefault();
          
          const localDateNow = getLocalDate();
          
          const inputTermination = {
              emailRequestor: authByToken.email,
              customerIdRequestor: authByToken.customer_id,
              terminationDate : localDateNow,
              selectedRows: selectedRows.map((row) => ({
              xcp_cable_id: row.xcp_cable_id,
              requestor_company: row.requestor_company,
              destination_company: row.destination_company,
              requestor_customer_id: row.requestor_customer_id,
              destination_customer_id: row.destination_customer_id,
              xcp_sales_order_no: row.xcp_sales_order_no,
              xcp_order_item_id: row.xcp_order_item_id,
              xcp_order_cable_id: row.xcp_order_cable_id,
            })),
          }
      
            try {
              const response = await fetch(
                "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/input-termination",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(inputTermination),
                }
              );
      
              const data = await response.json();
              const responseBody = JSON.parse(data.body);
              if (!response.ok) {
                setError(data.message || "Failed to submit form");
                throw new Error(data.message || "Failed to submit form");
              }
      
              const { message, xcp_termination_id } = responseBody;
              if (message == "success") {
                setOpenConfirm(false)
                // setOpenInputSuccess(true)
                await uploadTerminationLetter(xcp_termination_id)
              } else {
                setOpenConfirm(false)
                setOpenInputFail(true)
              }
            } catch (error) {
              console.error("Submission Error:", error.message);
              setError("Submission Error: " + error.message);
            }
        };

        async function uploadTerminationLetter(terminationId){
          setUploading(true);

          try {
            // Step 1: Get the presigned URL from the backend     
            const response = await axios.get(
              `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/upload-client-termination-letter?terminationId=${terminationId}&fileName=${file.name}`
            );
      
            if (response.status === 200) {
              const uploadUrl = response.data.uploadUrl;
      
              // Step 2: Upload the file to S3 using the presigned URL
              const responseUploadS3 = await axios.put(uploadUrl, file, {              
                headers: {
                  "Content-Type": file.type,
                },
              });

              if (responseUploadS3.status === 200) {
                    setOpenConfirm(false)
                    setOpenInputSuccess(true)
                } else {
                    setOpenConfirm(false)
                    setOpenInputFail(true)
                }
            } else {
              setError("File upload failed: " + response.message);
            }
          } catch (err) {
            setError("File upload failed");
            console.error("File upload failed", err);
          } finally {
            setUploading(false);
          }
        }

        const handleCheckboxChange = (termination, isChecked) => {
          setSelectedRows((prevSelectedRows) => {
            const updatedSelectedRows = isChecked
              ? [...prevSelectedRows, termination]
              : prevSelectedRows.filter((row) => row.xcp_cable_id !== termination.xcp_cable_id);
      
            return updatedSelectedRows;
          });
        };
      
        const handleClose = () => {
          setOpenConfirm(false);
          setOpenInputFail(false)
        };
      
        const handleConfirmation = async (event) => {
          event.preventDefault();
          if (!file) {
            setOpenConfirm(false);
            setErrorUpload("Please upload one a valid file");
            return;
          }
      
          if (file && !isValidFileName(file.name)) {
            setOpenConfirm(false);
            // Handle invalid file name
            setErrorUpload(
              "File name contains special characters. Please use only letters or numbers"
            );
            return;
          }

          
          const selectedCount = Object.keys(selectedRows).length
          if(selectedCount > 5) {
            window.scrollTo(0, 0);
            setError("Maximum number of rows selected is 5");
            
            return;
          } else if(selectedCount === 0){
            window.scrollTo(0, 0);
            setError("Minimum number of rows selected is 1");           
            return;
          }else {
            setOpenConfirm(true);
          }
        };
      
        function inputSuccess(){
          navigate("/termination-list")
        }

        const handleSelectChange = (event) => {
          setCurrentPage(1);
          setSelectedOption(event.target.value);
        };
      
        // cable id
        const handleCableIdChange = (event) => {
          setCurrentPage(1);
          setInputCableId(event.target.value);
        };

        // Sales Order No
        const handleSalesOrderNoChange = (event) => {
          setCurrentPage(1);
          setInputSalesOrderNo(event.target.value);
        };
      
        // requestor
        const handleRequestorChange = (event) => {
          setCurrentPage(1);
          setInputRequestor(event.target.value);
        };

        // destination
        const handleDestinationChange = (event) => {
          setCurrentPage(1);
          setInputDestination(event.target.value);
        };
      
        const handleSubmitCableId = (event) => {
          event.preventDefault();
          resetFiltersExcept("cableId");
          setSelectedCableId(inputCableId);
        };

        const handleSubmitSalesOrderNo = (event) => {
          event.preventDefault();
          resetFiltersExcept("salesOrderNo");
          setSelectedSalesOrderNo(inputSalesOrderNo);
        };
      
        const handleSubmitRequestor = (event) => {
          event.preventDefault();
          resetFiltersExcept("requestor");
          setSelectedRequestor(inputRequestor);
        };

        const handleSubmitDestination = (event) => {
          event.preventDefault();
          resetFiltersExcept("destination");
          setSelectedDestination(inputDestination);
        };

    //pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(10);
  
    // Get current orders
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentTermination = terminationListByRequestor.slice(indexOfFirstRow, indexOfLastRow);
  
    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const renderPaginationItems = () => {
      const pageNumbers = [];
      for (let i = 1; i <= Math.ceil(terminationListByRequestor.length / rowsPerPage); i++) {
        pageNumbers.push(
          <Pagination.Item key={i} active={i === currentPage} onClick={() => paginate(i)}>
            {i}
          </Pagination.Item>
        );
      }
      return pageNumbers;
    };

    //upload letter
        const [uploading, setUploading] = useState(false);
        const [file, setFile] = useState(null);
        
          const fileTypes = ["application/pdf"];
          const maxSize = 10 * 1024 * 1024; // 10MB
        
          const onDrop = useCallback((acceptedFiles) => {
            const selectedFile = acceptedFiles[0];
            setError(null); // Clear previous error
        
            // Validate file type
            if (!fileTypes.includes(selectedFile.type)) {
              setError("Invalid file type, upload a PDF format");
              setFile(null);
              return;
            }
        
            // Validate file size
            if (selectedFile.size > maxSize) {
              setError("File size exceeds 10MB, please upload file size below 10MB");
              return;
            }
        
            if (!selectedFile) {
              setError("No file selected");
              return;
            }
        
            setFile(selectedFile);
            setErrorUpload("")
          }, []);
        const { getRootProps, getInputProps } = useDropzone({
          onDrop,
          accept: fileTypes.join(","),
          multiple: false,
        });

        function isValidFileName(fileName) {
          // Regular expression to match special characters (excluding spaces and alphanumeric characters)
          const regex = /^[a-zA-Z0-9 ._-]+$/;
          return regex.test(fileName);
        }
  
    return (
        <div className="container-order-list">
          {/*<update-code */}
          <input type="hidden" name="token" value={tokenNow} /> {/* Hidden token field */}
            {/* update-code>*/}
            <h1>Cross Connect Termination Form</h1>
                <div className="title-order-input">   
                    <h6>Fulfill the termination form as follows.</h6> 
                    {error && <p className="error-message">{error}</p>}              
                </div>  

                <div className="title-order-input">                 
                  <h5>Filter</h5>
                </div>
                <form>
                  <div className="textbox-termination-list">
                    <label htmlFor="comboBox">Key</label>
                    <select id="comboBox" name="options" onChange={handleSelectChange}>
                      <option value="keyRequestor">Requestor</option>
                      <option value="keyCableId">Cable Id</option>
                      <option value="keySalesOrderNo">Sales Order</option>               
                      <option value="keyDestination">Destination</option>
                    </select>
                  </div>
                  {selectedOption === "key0" &&
                    selectedOption !== "keyCableId" &&
                    selectedOption !== "keySalesOrderNo" &&
                    selectedOption !== "keyRequestor" &&
                    selectedOption !== "keyDestination" &&       
                    (
                      <div className="value-order-list">
                        <div className="textbox-termination-list">
                          <label htmlFor="Value">Value</label>
                          <input type="text" placeholder="Value" />
                        </div>
                        <input
                          type="submit"
                          className="btn-submit-termination-list"
                          value="Search"
                        />
                      </div>
                    )}
                </form>
                {selectedOption === "keyCableId" && (
                  <form onSubmit={handleSubmitCableId}>
                    <div className="textbox-termination-list">
                      <label htmlFor="Requestor">Cable Id</label>
                      <input
                        type="text"
                        placeholder="Cable Id"
                        value={inputCableId}
                        onChange={handleCableIdChange}
                      />
                    </div>
                    <input
                      type="submit"
                      className="btn-submit-order-list"
                      value="Search"
                    />
                  </form>
                )}
                {selectedOption === "keySalesOrderNo" && (
                  <form onSubmit={handleSubmitSalesOrderNo}>
                    <div className="textbox-termination-list">
                      <label htmlFor="Sales Order">Sales Order</label>
                      <input
                        type="text"
                        placeholder="Sales Order"
                        value={inputSalesOrderNo}
                        onChange={handleSalesOrderNoChange}
                      />
                    </div>
                    <input
                      type="submit"
                      className="btn-submit-order-list"
                      value="Search"
                    />
                  </form>
                )}
                {selectedOption === "keyRequestor" && (
                  <form onSubmit={handleSubmitRequestor}>
                    <div className="textbox-termination-list">
                      <label htmlFor="Requestor">Requestor</label>
                      <input
                        type="text"
                        placeholder="Requestor"
                        value={inputRequestor}
                        onChange={handleRequestorChange}
                      />
                    </div>
                    <input
                      type="submit"
                      className="btn-submit-order-list"
                      value="Search"
                    />
                  </form>
                )}
                {selectedOption === "keyDestination" && (
                  <form onSubmit={handleSubmitDestination}>
                    <div className="textbox-order-list">
                      <label htmlFor="Destination">Destination</label>
                      <input
                        type="text"
                        placeholder="Destination"
                        value={inputDestination}
                        onChange={handleDestinationChange}
                      />
                    </div>
                    <input
                      type="submit"
                      className="btn-submit-order-list"
                      value="Search"
                    />
                  </form>
                )} 
                <div className='title-terminataion-input'> 
                  <h5>Termination Information</h5>
                </div>
                  
                 <div className="termination-date">
                    <label 
                    htmlFor="orderDate">Termination Date</label>
                    <input 
                    style={{
                      paddingLeft: "10px",
                      color: "black"
                      }} 
                    type="text" 
                    id="orderDate"            
                    value={getCurrentDate()}  
                    required
                    disabled
                    />
                </div> 
            <form onSubmit={handleConfirmation}>
               <div className="client-termination-letter">
                <label>Upload Client Termination Letter</label>
                    <div {...getRootProps()} className="dropzone">
                      <input {...getInputProps()} />
                      <FaCloudUploadAlt size={50} color="#007bff" />
                      <p>
                        Drag and drop a PDF file (max 10MB) here, or click to select one
                      </p>
                    </div>
                    {file && (
                      <div className="file-info">
                        <FaFilePdf size={40} color="#f40" />
                        <p>{file.name}</p>
                      </div>
                    )}
                    {errorUpload && <p className="error-message">{errorUpload}</p>}
                </div>  
                <div className="">   
                    <h6
                    style={{
                        marginTop: "50px"
                        }}>Select cable to be terminated</h6>               
                </div>  
                           
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col">Cable Id</th>
                        <th scope="col">Sales Order</th>
                        <th scope="col">Requestor</th>
                        <th scope="col">Destination</th>
                        <th scope="col">Select</th>
                    </tr>
                    </thead>
                    {currentTermination.map((termination,index) => (
                        <tbody>
                        <tr key={termination.xcp_cable_id}>
                        <td>{indexOfFirstRow + index + 1}</td>
                        <td>{termination.xcp_cable_id}</td>
                        <td>{termination.xcp_sales_order_no}</td>
                        <td>{termination.requestor_company}</td>
                        <td>{termination.destination_company}</td>
                        <td>
                            <input
                            type="checkbox"
                            checked={selectedRows.some((row) => row.xcp_cable_id === termination.xcp_cable_id)}
                            onChange={(e) =>
                                handleCheckboxChange(termination, e.target.checked)
                            }
                            />
                        </td>
                        </tr>
                    </tbody>
                        ))}          
                </table>
                <Pagination>
                  <Pagination.First onClick={() => paginate(1)} />
                  <Pagination.Prev onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)} />
                  {renderPaginationItems()}
                  <Pagination.Next onClick={() => paginate(currentPage < Math.ceil(terminationListByRequestor.length / rowsPerPage) ? currentPage + 1 : currentPage)} />
                  <Pagination.Last onClick={() => paginate(Math.ceil(terminationListByRequestor.length / rowsPerPage))} />
                </Pagination>
                    <input
                    type="submit"
                    className="btn-submit-input-termination"
                    value="Submit"
                />
            </form> 

            <Dialog open={openConfirm}>
                <DialogTitle>{"Are you sure you want to input this termination?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Clicking "Yes" will input this termination.
                        </DialogContentText>
                    </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button onClick={handleSubmit} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
                </Dialog> 
                <Dialog open={openInputSuccess}>
                <DialogTitle>{"Input Termination Form submitted successfully"}</DialogTitle>
                <DialogActions>
                    <Button onClick={inputSuccess} color="primary" autoFocus>
                    Ok
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openInputFail}>
                <DialogTitle>{"Input Termination Form submitted failed"}</DialogTitle>
                <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Ok
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default TerminateOrder;
